import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./ShopByCategory.css";

// Import your video file from assets
import serviceVideo from "../Assets/service.mp4"; // Update with your actual video path

const ServiceRequestForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    phoneNumber: "",
    brand: "",
    model: "",
    image: null,
    video: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, image: file });
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, video: file });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requestData = new FormData();
    requestData.append("firstName", formData.firstName);
    requestData.append("lastName", formData.lastName);
    requestData.append("address", formData.address);
    requestData.append("city", formData.city);
    requestData.append("phoneNumber", formData.phoneNumber);
    requestData.append("brand", formData.brand);
    requestData.append("model", formData.model);
    if (formData.image) {
      requestData.append("image", formData.image);
    }
    if (formData.video) {
      requestData.append("video", formData.video);
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("❌ Authentication required. Please log in again.");
        return;
      }

      await axios.post("https://madhusewingmachines.com/api/service-requests", requestData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`,
        },
      });

      toast.success("🎉 Your service request has been submitted successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        phoneNumber: "",
        brand: "",
        model: "",
        image: null,
        video: null,
      });
    } catch (error) {
      console.error("Service Request Submission Error:", error);
      let errorMessage = "❌ Failed to submit service request. Please try again.";
      if (error.response?.status === 401) {
        errorMessage = "❌ Session expired. Please log in again.";
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
      toast.error(errorMessage);
    }
  };

  return (
    <div style={{ backgroundColor: "#EFFBFF", minHeight: "100vh", padding: "2rem 0", paddingTop: "120px" }}>
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} className="text-center">
            <h2 className="category-heading">Service Request🛠️</h2>
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} lg={5} className="mb-4 mb-lg-0">
            <div className="p-5 shadow rounded bg-white">
              <Form onSubmit={handleSubmit}>
                {/* Form fields remain the same */}
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="phoneNumber" placeholder="Phone Number" value={formData.phoneNumber} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Select name="brand" value={formData.brand} onChange={handleChange} required>
                    <option value="">Select a brand</option>
                    <option value="Singer">Singer</option>
                    <option value="Brother">Brother</option>
                    <option value="Usha">Usha</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="model" placeholder="Model" value={formData.model} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Upload Image</Form.Label>
                  <Form.Control type="file" accept="image/jpeg, image/png" onChange={handleFileChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Upload Video</Form.Label>
                  <Form.Control type="file" accept="video/*" onChange={handleVideoChange} />
                </Form.Group>
                <Button type="submit" className="w-100 fw-bold" style={{ backgroundColor: "#64C3F9", border: "none" }}>
                  Submit Request
                </Button>
              </Form>
            </div>
          </Col>
          <Col xs={12} lg={5} className="text-center d-none d-lg-block">
            {/* Replaced image with video */}
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{ maxWidth: "100%", borderRadius: "10px",height:"980px" }}
            >
              <source src={serviceVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default ServiceRequestForm;